export const categoryOptions = [
  { key: 'Client', value: 'Client', icon: 'user', text: 'Client' },
  { key: 'Employés', value: 'Employés', icon: 'user circle', text: 'Employés' }
];

export const yesOrNo = [
  { key: 'OUI', value: 'OUI', text: 'OUI' },
  { key: 'NON', value: 'NON', text: 'NON' }
];

export const userOptions = [
  {
    key: 'Responsable de suivi',
    value: 'ADMIN',
    icon: 'user',
    text: 'Responsable de suivi'
  },
  {
    key: 'Responsable de traitement',
    value: 'ADMIN',
    icon: 'user',
    text: 'Responsable de traitement'
  },
  {
    key: 'Agent de traitement',
    value: 'ADMIN',
    icon: 'user circle',
    text: 'Agent de traitement'
  }
];

export const complaintOptions = [
  {
    key: 'Membre du personnel',
    value: 'Membre du personnel',
    icon: 'address book',
    text: 'Membre du personnel'
  },
  {
    key: 'Employés',
    value: 'Employés',
    icon: 'address card',
    text: 'Employés'
  }
];

export const problemOptions = [
  {
    key: 'Exigences procédurales',
    value: 'Exigences procédurales',
    icon: 'user',
    text: 'Exigences procédurales'
  },
  {
    key: 'Exigences normatives',
    value: 'Exigences normatives',
    icon: 'user circle',
    text: 'Exigences normatives'
  },
  {
    key: 'Exigences légales et réglementaires',
    value: 'Exigences légales et réglementaires',
    icon: 'user',
    text: 'Exigences légales et réglementaires'
  },
  {
    key: 'Exigences contractuelles',
    value: 'Exigences contractuelles',
    icon: 'user circle',
    text: 'Exigences contractuelles'
  },
  {
    key: "Accidents, incidents et situations d'urgences",
    value: "Accidents, incidents et situations d'urgences",
    icon: 'user',
    text: "Accidents, incidents et situations d'urgences"
  },
  {
    key: "Non atteinte d'objectif",
    value: "Non atteinte d'objectif",
    icon: 'user circle',
    text: "Non atteinte d'objectif"
  },
  {
    key: 'Ecart sur activités / actions / planning',
    value: 'Ecart sur activités / actions / planning',
    icon: 'user',
    text: 'Ecart sur activités / actions / planning'
  },
  {
    key: 'Amélioration nécessaire dans le fonctionnement',
    value: 'Amélioration nécessaire dans le fonctionnement',
    icon: 'user circle',
    text: 'Amélioration nécessaire dans le fonctionnement'
  },
  {
    key: "Opportunité d'amélioration (après audits, RD, etc)",
    value: "Opportunité d'amélioration (après audits, RD, etc)",
    icon: 'user',
    text: "Opportunité d'amélioration (après audits, RD, etc)"
  },
  {
    key: 'Après analyse de données',
    value: 'Après analyse de données',
    icon: 'user circle',
    text: 'Après analyse de données'
  },
  { key: 'Autres', value: 'Autres', icon: 'user', text: 'Autres' }
];

export const actionOptions = [
  {
    key: 'NC (Non-conformité)',
    value: 'NC (Non-conformité)',
    icon: 'user',
    text: 'NC (Non-conformité)'
  },
  {
    key: 'AC (Action corrective)',
    value: 'AC (Action corrective)',
    icon: 'user circle',
    text: 'AC (Action corrective)'
  },
  {
    key: 'AP (Action préventive)',
    value: 'AP (Action préventive)',
    icon: 'user circle',
    text: 'AP (Action préventive)'
  }
];
export const statusOptions = [
  {
    key: 'Brute',
    value: 'Brute',
    icon: 'user',
    text: 'Brute'
  },
  {
    key: 'Traitement en cours',
    value: 'Traitement en cours',
    icon: 'user circle',
    text: 'Traitement en cours'
  },
  {
    key: 'Délibérée',
    value: 'Délibérée',
    icon: 'user circle',
    text: 'Délibérée'
  }
];

export const avatarOptions = [
  {
    key: 'Jenny Hess',
    text: 'Jenny Hess',
    value: 'Jenny Hess',
    image: { avatar: true, src: '/assets/images/avatar/small/jenny.jpg' }
  },
  {
    key: 'Elliot Fu',
    text: 'Elliot Fu',
    value: 'Elliot Fu',
    image: { avatar: true, src: '/assets/images/avatar/small/elliot.jpg' }
  },
  {
    key: 'Stevie Feliciano',
    text: 'Stevie Feliciano',
    value: 'Stevie Feliciano',
    image: { avatar: true, src: '/assets/images/avatar/small/stevie.jpg' }
  },
  {
    key: 'Christian',
    text: 'Christian',
    value: 'Christian',
    image: { avatar: true, src: '/assets/images/avatar/small/christian.jpg' }
  }
];
